
import React from 'react';
import { Box, Container, Grid } from '@mui/material';
import PrimaryContent from '../../Utilities/PrimaryContent';
import PrimaryHeading from '../../Utilities/PrimaryHeading';

export default function AIPoweredFeatures() {
  return (
    <Container maxWidth='xl'
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minHeight: '400px',
        paddingTop: '80px',
        paddingBottom: '10px',
      }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={5}>
          <Box>
            <img
              src="/images/ai-powered-features.svg"
              alt="NC Pro"
              style={{ maxWidth: "100%", height: "auto" }}
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={7}>
          <Box>
            <Box>
              <PrimaryHeading sx={{
                textAlign: { xs: 'center', md: 'end' },
                paddingBottom: '30px'
              }}><span style={{
                color: 'white',
                background: 'linear-gradient(270.29deg, #43B0D7 0.24%, #0D2663 99.75%)',
                opacity: '90%',
                marginRight: '5px',
              }}>AI-Powered</span>
                features that set NC pro Apart
              </PrimaryHeading>
              <PrimaryContent sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                At GB International, we’ve incorporated advanced AI technologies to enhance the 8D process, making NC pro not only smarter but also more efficient. These features offer you unprecedented control over quality management.
              </PrimaryContent>
            </Box>
            <Box sx={{ my: 5 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    border: '1px solid #EBEBEB',
                    borderRadius: '15px',
                    p: 2,
                  }}>
                    <img
                      src="/images/01.png"
                      alt="NC Pro"
                      style={{ maxWidth: "45px", height: "auto", marginRight: '15px' }}
                    />
                    <PrimaryContent variant="subtitle1" sx={{ fontStyle: 'italic', mt: 1, color: '#000000' }}>
                      NC Searching Technology
                    </PrimaryContent>
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    border: '1px solid #EBEBEB',
                    borderRadius: '15px',
                    p: 2,
                  }}>
                    <img
                      src="/images/02.png"
                      alt="NC Pro"
                      style={{ maxWidth: "45px", height: "auto", marginRight: '15px' }}
                    />
                    <PrimaryContent variant="subtitle1" sx={{ fontStyle: 'italic', mt: 1, color: '#000000' }}>
                      AI-Assisted Problem Statement
                    </PrimaryContent>
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    border: '1px solid #EBEBEB',
                    borderRadius: '15px',
                    p: 2,
                  }}>
                    <img
                      src="/images/03.png"
                      alt="NC Pro"
                      style={{ maxWidth: "45px", height: "auto", marginRight: '15px' }}
                    />
                    <PrimaryContent variant="subtitle1" sx={{ fontStyle: 'italic', mt: 1, color: '#000000' }}>
                      Corrective Action Suggestions
                    </PrimaryContent>
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    border: '1px solid #EBEBEB',
                    borderRadius: '15px',
                    p: 2,
                  }}>
                    <img
                      src="/images/04.png"
                      alt="NC Pro"
                      style={{ maxWidth: "45px", height: "auto", marginRight: '15px' }}
                    />
                    <PrimaryContent variant="subtitle1" sx={{ fontStyle: 'italic', mt: 1, color: '#000000' }}>
                      One-Click Reporting
                    </PrimaryContent>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Container>
  )
}